import React, { VFC } from 'react';
import { QueryClientProvider } from 'react-query';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ReactQueryDevtools } from 'react-query/devtools';
import { theme } from './styles/theme';
import { Routes } from './routes';
import './interceptors/addTokenRequest';
import { queryClient } from './utils/react-query';
import { AuthProvider, SidebarProvider, TelemetryProvider } from './contexts';
import { FilterProvider } from './contexts/FilterContext/FilterContext';
import { DownloadProvider } from '~/contexts/DownloadContext/DownloadContext';

const App: VFC = () => {
  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TelemetryProvider>
            <SidebarProvider>
              <FilterProvider>
                <DownloadProvider>
                  <Router>
                    <Routes />
                  </Router>
                </DownloadProvider>
              </FilterProvider>
            </SidebarProvider>
          </TelemetryProvider>
        </AuthProvider>
        {process.env.NODE_ENV !== 'production' && <ReactQueryDevtools />}
      </QueryClientProvider>
    </ChakraProvider>
  );
};

export default App;
